import { useMemo } from 'react';

function printAST(root, printers, interceptor) {
  const printNodes = (parent, nodes, printers2, depth) => {
    const output = toArray(nodes).map((input, index) => {
      const printer = printers2[input.nodeType];
      const context = {
        index,
        depth,
        parentNode: parent,
        siblingNodes: toArray(nodes),
        printChildren: (children, printers3) => (
          // @ts-expect-error TPrinterOut will be assignable to TOut
          printNodes(
            input,
            children,
            printers3,
            depth + 1
          )
        )
      };
      const output2 = printer == null ? void 0 : printer(input, context);
      return output2 != null && interceptor ? interceptor(input, output2, context) : output2;
    }).filter((it) => it != null);
    return output;
  };
  return printNodes(
    null,
    root,
    printers,
    0
  );
}
function usePrintedAST(root, printers, interceptor, ...extraDeps) {
  return useMemo(
    () => printAST(root, printers, interceptor),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [root, ...extraDeps ?? []]
  );
}
function toArray(input) {
  if (input === null) {
    return [];
  }
  return Array.isArray(input) ? input : [input];
}

export { printAST, toArray, usePrintedAST };
//# sourceMappingURL=core.print-ast.js.map
